<script>
import axios from 'axios'
import { API_SVC_HOST } from '@/config/common';
import { authStatus } from '@/service';
import Footer from "@/components/footer";
import appConfig from "../../../app.config";
import _ from 'lodash';

export default {
  page: {
    title: "Authentication",
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
    };
  },
  components: {
    Footer,
  },
  computed: {
    sessionId() {
      return this.$route.query.session_id || ""
    },
    redirect() {
      return localStorage.getItem("login_redirect") || "/"
    },
    api_host() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/")
    },
    notification() {
      return this.$store ? this.$store.state.notification : null;    
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
  },
  mounted() {
    let is_logout = sessionStorage.getItem("is_logout")
    if (is_logout === "true") {
      this.ReLogin()
    }

    if(this.sessionId == "")
    {
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push('/')
    }
    else{
      let config = {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true
      }
      axios.get( this.api_host + '/session/token', config).then((res)=>{
        localStorage.setItem('accessToken', res.data.accessToken);
        localStorage.setItem('refreshToken', res.data.refreshToken);
        localStorage.setItem('expiresAt', res.data.expiresAt);
        localStorage.setItem('refreshExpiresIn', res.data.refreshExpiresIn || res.data.expiresAt);

        authStatus(this.redirect)
        // window.location.href = this.redirect
      })
    }
  },
  methods: {
    ReLogin() {
      sessionStorage.removeItem("is_logout")
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      setTimeout(() => {
        localStorage.clear()
      }, 2000);
    },
    getCookie(session_id) {
        const domain = window.location.domain
        const now = new Date()
        const expireDate = new Date(now.getTime() + 1 * 60 * 60 * 1000)
        const expires = `expires=${expireDate.toUTCString()}`
        return `SESSION=${session_id}; ${expires}; path=/; domain=${domain};`
    }
  },
};
</script>

<template>
  <div v-if="notification.message" class="auth-page-wrapper pt-5">
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
      <div class="bg-overlay"></div>

      <div class="shape">

        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1440 120">
          <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
        </svg>
      </div>
      <Particles id="tsparticles" :options="{
        particles: {
          number: {
            value: 90,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: '#ffffff',
          },
          shape: {
            type: 'circle',
            stroke: {
              width: 0,
              color: '#000000',
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: 'img/github.svg',
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.8,
            random: true,
            anim: {
              enable: true,
              speed: 1,
              opacity_min: 0,
              sync: false,
            },
          },
          size: {
            value: 4,
            random: true,
            anim: {
              enable: false,
              speed: 4,
              size_min: 0.2,
              sync: false,
            },
          },
          line_linked: {
            enable: false,
            distance: 150,
            color: '#ffffff',
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 2,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'bubble',
            },
            onclick: {
              enable: true,
              mode: 'repulse',
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 4,
              duration: 2,
              opacity: 0.8,
              speed: 3,
            },
            repulse: {
              distance: 200,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
        config_demo: {
          hide_card: false,
          background_color: '#b61924',
          background_image: '',
          background_position: '50% 50%',
          background_repeat: 'no-repeat',
          background_size: 'cover',
        },
      }" />
    </div>

    <div class="auth-page-content">
      <b-container>
        <b-row>
          <b-col lg="12">
            <div class="text-center pt-4">
              <div class="">
                <img src="@/assets/images/error.svg" alt="" class="error-basic-img move-animation">
              </div>
              <div class="mt-n4">
                <h1 class="display-1 fw-medium">{{ notification.type }}</h1>
                <h3 class="text-uppercase">{{ notification.message }}</h3>
                <p class="text-muted mb-4">The page you are looking for not available!</p>
                <b-link class="btn btn-success" @click="ReLogin"><i class="mdi mdi-home me-1"></i>Go Login</b-link>
              </div>
            </div>
          </b-col>
        </b-row>

      </b-container>
    </div>

    <Footer />
  </div>
  <form
    id="frm_logout"
    method="post"
    action=""
    style="display: none">
  </form>
</template>